export default __webpack_public_path__ + "static/media/linkedIn_icon.05f86fbe.svg";